import React from 'react';
import { ProductionPlantBasicInfoComponent } from './production-plant-basic-info.component';
import ProductionPlantAddressComponent from './production-plant-address.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

function ProductionPlantComponent ({ handleInnerbasicFormChange, back, handleFormSubmit, onInnerFormChange, organizationUnits, selectedAddress, selectedProductionPlant }: any) {
    const tabItems=[
        {
            id:1,
            title:'Basic Information',
            component:  <ProductionPlantBasicInfoComponent
            onInnerFormChange={onInnerFormChange}
            organizationUnits={organizationUnits}
            selectedProductionPlant={selectedProductionPlant}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'Address',
            component: <ProductionPlantAddressComponent
                     handleInnerbasicFormChange={handleInnerbasicFormChange}
                     selectedAddress={selectedAddress} 
                     onInnerFormChange={onInnerFormChange}
                     selectedProductionPlant={selectedProductionPlant} 
                     />,
            isVisible:true,
        }
     
      
      ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  );
}
export default ProductionPlantComponent;
